<template>
    <v-container>
        <v-layout justify-center wrap>
            <v-flex xs12>
                <w-main-title
                        class="pb-0"
                        title="Servicios"
                        :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
            <v-flex xs12>
                <provider-services-list/>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import WMainTitle from '@/components/common/WMainTitle'
    import ProviderServicesList from '@/components/providers/services/ProviderServicesList'
    export default{
        components: {
            WMainTitle,
            ProviderServicesList
        },
        data(){
            return {
                breadcrumbs: [
                    {
                        text: 'Institución',
                        disabled: true,
                        href: ''
                    },
                ]
            }
        },
        computed: {}
    }
</script>